// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"f991c0a2","123":"ff4fad6b","210":"f3e49a44","272":"1691d2db","600":"23ecef64","612":"16301ccc"}[chunkId] + ".chunk.js";
};